import notifications from '@sigma-frontend-libs/messages/en/notifications'
import sendings from '@sigma-frontend-libs/messages/ru/sendings'

export default {
  titles: {
    variables: 'Variables'
  },

  labels: {
    notification: 'Notification',
    subject: 'Subject',
    body: 'Body template',
    channel: 'Channel',
    owner: 'Recipient',
    targetUser: 'Recipient',
    type: 'Type',
    text: 'Text',
    sentAt: 'Sent at',
    isRead: 'Status'
  },

  hints: {
    variables: 'Please refer to the documentation for detailed guidance on correctly filling out templates and using variables.'
  },

  channels: sendings.types,
  events: notifications.types,
  childrenUsersEvents: notifications.types,

  email: {
    smtp: {
      host: 'Host',
      port: 'Port',
      from: 'From',
      login: 'Login',
      password: 'Password'
    },

    templates: notifications.types
  },

  sms: {
    sendername: 'Sender name',
    senderUserId: 'Sender',
    templates: notifications.types
  },

  web: { templates: notifications.types },
  push: { templates: notifications.types },
  tgBot: { templates: notifications.types },

  snackbars: {
    updated: 'Setting successfully updated.'
  },

  isRead: {
    true: 'Read',
    false: 'Unread',
    sent: 'Sent: {date}',
    delivered: 'Delivered: {date}'
  },

  tooltips: {
    channel: {
      on: 'Enabled',
      off: 'Disabled'
    }
  }
}

